import actions from './actions';

const {
  ADD_BEGIN,
  ADD_SUCCESS,
  ADD_ERR,

  READ_BEGIN,
  READ_SUCCESS,
  READ_ERR,

  UPDATE_BEGIN,
  UPDATE_SUCCESS,
  UPDATE_ERR,

  DELETE_BEGIN,
  DELETE_SUCCESS,
  DELETE_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const agentsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case READ_BEGIN:
      return {
        ...state,
        data: [],
        loading: true,
      };

    case READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { agentsReducer };
